"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEngineUrl = void 0;
const engineLookup = {
    deepl: "https://www.deepl.com/translator#-/-/",
    duckduckgo: "https://duckduckgo.com/?q=",
    ecosia: "https://www.ecosia.org/search?q=",
    google: "https://www.google.com/search?q=",
    startpage: "https://www.startpage.com/search?q=",
    youtube: "https://www.youtube.com/results?q=",
};
const getEngineUrl = (engine) => engineLookup[engine];
exports.getEngineUrl = getEngineUrl;
